import { render, staticRenderFns } from "./assess.vue?vue&type=template&id=9b2c3b7a&scoped=true"
import script from "./assess.vue?vue&type=script&lang=js"
export * from "./assess.vue?vue&type=script&lang=js"
import style0 from "./assess.vue?vue&type=style&index=0&id=9b2c3b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2c3b7a",
  null
  
)

export default component.exports